import React, { useState, useRef, useEffect } from 'react'

import useIsFirstRender from '../../is_first_render.js'

import useInteractionZone from './InteractiveZone.jsx'

import { gsap } from 'gsap'
import { useGSAP } from '@gsap/react'

import ahoy from "ahoy.js"

const ScrollIcon = ({ direction }) => (
	<svg
		width="300"
		height="50px"
		viewBox="0 0 100 48"
		preserveAspectRatio="none"
		className={`scroll-arrows-${direction}`}
	>
		<g className="arrow-group">
			<path
				className="arrow arrow1"
				d="M0 0 L50 18 L100 0"
				stroke="currentColor"
				strokeWidth="3"
				fill="none"
			/>
			<path
				className="arrow arrow2"
				d="M0 2 L50 32 L100 2"
				stroke="currentColor"
				strokeWidth="3"
				fill="none"
			/>

			<path
				className="arrow arrow3"
				d="M0 4 L50 43 L100 4"
				stroke="currentColor"
				strokeWidth="3"
				fill="none"
			/>
		</g>
	</svg>
)

const ScrollArrowsDown = () => <ScrollIcon direction="down" />
const ScrollArrowsUp = () => <ScrollIcon direction="up" />

const ExperienceText = ({ text, text_rect, text_interaction_zone_rect }) => {
	const [show, setShow, interactionZone] = useInteractionZone(text_interaction_zone_rect)
	const [availableScroll, setAvailableScroll] = useState({ top: 0, bottom: 0 })

	const is_first_render = useIsFirstRender()

	const text_ref = useRef(null)
	const root_ref = useRef(null)

	// TODO: replace gsap. It's pretty dumb. Arghhgh.
	useGSAP(
		() => {
			if(is_first_render){
				return
			}

			const text = text_ref.current

			gsap.set(text, { opacity: show ? 0 : 1 })
			gsap.to(text, {
				opacity: show ? 1 : 0,
				overwrite: 'auto', // 🔐 esto es clave
			})
		},
		{ dependencies: [show], revertOnUpdate: true }
	)

	useEffect(()=>{
		if(!show && root_ref.current){
			// TODO: 450 based on text fade out animation duration
			setTimeout(()=> {
				if(root_ref.current){
					root_ref.current.scrollTo(0,0)
				}
			}, 450)
		}

		if(!is_first_render){
			ahoy.track('ExperienceText', { action: show ? 'show' : 'hide' })			
		}
	}, [show])

	const calculateAvailableScroll = ({ scrollTop, scrollHeight, clientHeight }) => ({
		top: scrollTop,
		bottom: scrollHeight - ( scrollTop + clientHeight )
	})

	useEffect(()=>{
		const root = root_ref.current

		if(root){
			setAvailableScroll(calculateAvailableScroll(root))
		}
	}, [root_ref.current, show])


	const onScroll = ({ target }) => {
		const log_available_scroll = calculateAvailableScroll(target)

		//phone_log(`scroll: ${log_available_scroll.bottom}`)

		setAvailableScroll(log_available_scroll)
	}

	return (
		<div className="ExperienceTextt" style={{
					width: 100 + '%',
					height: 100 + '%',
					overflow: 'hidden'
				}} >
			<div
				ref={root_ref}
				onScroll={onScroll}
				onScrollEnd={() => setAvailableScroll({ top: 0, bottom: 0 })}
				className={
					`absolute
					text-white text-center
					drop-shadow-experience2 text-shadow-strong
					-translate-x-1/2 -translate-y-1/2
					select-none scrollbar-hide
					experience-text
					z-10
					p-3
					${show ? 'cursor-pointer experience-text-box-shadow' : ''}
					`
				}
				style={{
					left: text_rect.left + '%',
					top: text_rect.top + '%',
					width: text_rect.width + '%',
					height: text_rect.height + '%',
					overflow: 'auto'
				}}
			>
				<div
					ref={text_ref}
					className={`
						absolute
						border-red-950 border-solid

						opacity-0
						text-xxs md:text-md lg:text-xl xl:text-3xl
					`}
					onClick={()=> setShow(false)}
					style={{
						pointerEvents: show ? 'auto' : 'none',
						zIndex: show ? 7 : 2
					}}
				>
					{text}
				</div>

				{interactionZone}
			</div>

			{show && (availableScroll.bottom > 0.67) && <span className={`
					absolute
					-translate-x-1/2
					app-animated-arrow
				`}
				style={{
					left: (text_rect.left) + '%',
					top: (text_rect.top + text_rect.height/2) + '%',
					width: text_rect.width + '%',
					height: '5%',
					zIndex: show ? 7 : 2
				}}
			><ScrollArrowsDown /></span>}
		</div>
	)
}

export default ExperienceText